exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".user-table .col-phone{width:140px}.user-table .col-actions{width:120px}md-lookup .input-field{width:75%}", ""]);

